module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Left Chaise_Green.a5e10844.png";